import Loader from "components/Loader/Loader";
import { commitMutation, QueryRenderer as QR } from "react-relay";
import {
    Environment,
    fetchQuery as fQ,
    getRequest,
    Network,
    RecordSource,
    Store
} from "relay-runtime";
import { AUTH_TOKEN } from "utils/constants";
import config from "./config";

const handlerProvider = null;
const source = new RecordSource();
const store = new Store(source);

async function postGraphql(text: any, variables: any) {
    const authToken = window.localStorage.getItem(AUTH_TOKEN);
    let headers: any = { "Content-Type": "application/json", "Accept": "application/json" };
    if (authToken) {
        headers["Authorization"] = "JWT " + authToken;
    }
    const response = await fetch(`${config}/graphql`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            query: text,
            variables,
        }),
    });
    return await response.json();
}

const network = Network.create(function fetchQuery(operation, variables) {
    return postGraphql(operation.text, variables);
});

const environment = new Environment({
    handlerProvider,
    network,
    store,
});

function mutateBase(props: any) {
    const onCompleted = (response: any, errors: any) => {
        if (errors && errors.length > 0) {
            var messages: string[] = [];
            errors.forEach((err: any) => {
                messages.push(err.message);
            });
            if (props.onFailure) {
                return props.onFailure(messages);
            } else {
                return alert(messages.join("; "));
            }
        }
        return props.onSuccess(response);
    };
    return commitMutation(props.environment, {
        mutation: props.mutation,
        variables: props.variables,
        onCompleted: onCompleted,
        // A network failure used to leave callers waiting forever.
        onError: props.onFailure
            ? (error: any) => props.onFailure([error?.message || "Something went wrong. Please try again."])
            : undefined,
    });
}

function mutate(props: any) {
    return mutateBase({
        mutation: props.mutation,
        variables: props.input,
        onSuccess: props.onSuccess,
        onFailure: props.onFailure,
        environment,
    });
}

function QueryRenderer(_props: any) {
    const component = (
        <QR
            environment={environment}
            render={({ error, props }: { error: any; props: any }) => {
                if (error) {
                    return <div> {error.message} </div>;
                }
                if (props && Object.keys(props).length > 0) {
                    return _props.onSuccess(props);
                }
                if (_props.isTable) {
                    return (
                        <tr>
                            <td>Loading...</td>
                        </tr>
                    );
                }
                if (_props.isSelect) {
                    return <option>Loading...</option>;
                } else {
                    return <Loader />;
                }
            }}
            {..._props}
        />
    );
    return component;
}

function fetchQuery(query: any, variables = {}) {
    return fQ(environment, query, variables);
}

// Like fetchQuery, but also returns the server's error messages. Relay drops
// the errors of a nullable field that failed (its value just comes back null),
// so callers that must show the server's reason use this. Not cached in the store.
async function fetchQueryWithErrors(query: any, variables = {}) {
    const response = await postGraphql(getRequest(query).params.text, variables);
    const errors: string[] = (response.errors || []).map((err: any) => err.message);
    return { data: response.data || {}, errors };
}

export { QueryRenderer, mutate, fetchQuery, fetchQueryWithErrors, environment, mutateBase };
